<template>
  <!-- 认证弹窗certification -->
  <div class="certification">
    <el-dialog
      title="手机号登录"
      width="366px"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <div class="login-main">
        <img src="../../assets/img/手机.png" alt="" />
        <el-form ref="form" :model="form" :rules="rules" label-width="80px">
          <el-form-item prop="phone">
            <el-input
              v-model="form.phone"
              @blur="blurPhone"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
          <el-form-item prop="passworld">
            <!-- <el-input v-model="form.passworld" placeholder="请输入验证码"> -->
            <el-input
              v-model="form.passworld"
              placeholder="请输入登录密码"
              show-password
            >
            </el-input>
          </el-form-item>
          <!-- <el-button v-if="isshowMsgCode" class="code" @click="SendCode"
          >发送验证码</el-button
        >
        <div
          class="msg_btn"
          @click="handleMsgVCode"
          disabled
          v-if="!isshowMsgCode"
        >
          <span>{{ countTime }}秒后重新发送</span>
        </div> -->
          <p class="ForgetPassword" @click="ForgetPassword">忘记密码？</p>
          <el-form-item>
            <el-button type="primary" @click="submitForm" v-loading="loading"
              >登录</el-button
            >
          </el-form-item>
        </el-form>
        <!-- 用户服务协议 -->
        <div>
          <el-checkbox v-model="checked"
            ><span>我已阅读并同意</span>
          </el-checkbox>
          <span class="UserAgreement" @click="UserAgreementHandle"
            >《用户服务协议》</span
          >
          <!-- <div class="forget" @click="ForgetHandle">
          还没账号？去注册
        </div> -->
        </div>
      </div>
    </el-dialog>

    <!-- 注册弹窗 -->
    <!-- <Registered
      v-on="$listeners"
      :loginsInfo="registeredInfo"
      :visible.sync="registeredInfo.dialogVisible"
    ></Registered> -->
  </div>
</template>

<script>
// 注册弹窗
import Registered from "../../components/Dialog/Registered.vue";
// 引入接口
import { GetVerificationCode } from "@/api/user.js";
import { initMenu } from "../../utils/permission";
// 辅助函数
import { mapGetters } from "vuex";
const TIME_COUNT = 60;
export default {
  name: "certification",
  props: {
    loginsInfo: {
      // 表格数据
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  components: {
    Registered
  },
  data() {
    return {
      // 表单数据
      form: {
        phone: "",
        passworld: ""
      },
      validation: {
        Phone: "",
        VerificationCode: ""
      },
      // 需要重置得手机号
      restPhone: "",
      rules: {
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            required: true,
            pattern: /^1[3456789]\d{9}$/,
            message: "手机号格式不正确",
            trigger: "blur"
          }
        ],
        passworld: [
          // { required: true, message: "请输入正确得验证码", trigger: "blur" }
          { required: true, message: "请输入登录密码", trigger: "blur" }
        ]
      },
      // 倒计时
      isshowMsgCode: true,
      timer: null,
      countTime: "",
      // 单选按钮
      checked: false,
      loading: false
    };
  },
  computed: {
    ...mapGetters(["userInfo", "users"]),
    hasToken: {
      get() {
        return this.$store.state.users.token;
      }
    },
    userInfos: {
      get() {
        return this.$store.state.users.userInfo;
      }
    },
    dialogVisible: {
      get() {
        return this.loginsInfo.dialogVisible;
      },
      set(value) {
        this.$emit("update:visible", value);
      }
    },
    ResetPassword: {
      get() {
        return this.$store.state.users.ResetPassword;
      }
    },
    registeredInfo: {
      get() {
        return this.$store.state.users.registeredInfo;
      }
    },

    forgetPassword: {
      get() {
        return this.$store.state.users.ForgetPassword;
      }
    }
  },

  methods: {
    // 注册
    ForgetHandle() {
      // 注册
      this.registeredInfo.dialogVisible = true;
      this.dialogVisible = false;
    },
    ForgetPassword() {
      this.checked = false;
      this.$refs["form"].resetFields();
      this.forgetPassword.dialogVisible = true;
      this.dialogVisible = false;
    },
    blurPhone() {
      console.log(1111);
    },
    handleConfirm() {
      // this.$refs.mychild.submitForm();
      // 触发父组件的方法 点击保存的方法
      this.$emit("confirm");
      this.$emit("update:visible", false);
    },
    handleCancel() {
      this.$emit("Cancel");
      this.$emit("update:visible", false);
    },
    handleClose() {
      this.checked = false;
      this.$refs["form"].resetFields();
      this.$emit("update:visible", false);
    },
    // 登录
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (!this.checked) {
            this.$message({
              message: "请勾选用户协议!",
              type: "warning",
              customClass: "messageIndex"
            });
          } else {
            this.loading = true;
            this.$store
              .dispatch("users/login", this.form)
              .then(async data => {
                if (
                  data.User &&
                  (data.User.FullID === 2 || data.User.FullID === 3)
                ) {
                  this.$message("暂不支持登录");
                  // if (
                  //   this.$router.app._route.meta.title == "视频播放" ||
                  //   this.$router.app._route.meta.title == "个人中心" ||
                  //   this.$router.app._route.meta.title == "论坛详情"
                  // ) {
                  //   await this.$store.dispatch("users/getUserData");
                  //   // 不跳转但是需要关闭弹窗
                  //   this.$emit("update:visible", false);
                  //   this.$router.go(0);
                  //   this.loading = false;
                  // } else {
                  //   this.$router.push("/Home");
                  //   this.$emit("changeTopNav", "首页");
                  //   this.$emit("update:visible", false);
                  //   this.loading = false;
                  // }
                } else {
                  // 等待路由加载
                  const oRouter = await this.$store.dispatch("users/getMenu");
                  console.log(oRouter[0].path);
                  this.$router.push(oRouter[0].path);
                  this.$emit("update:visible", false);
                  this.loading = false;
                }
                // 登录成功，清空验证码和手机号
                this.$refs["form"].resetFields();
                this.checked = false;
                this.validation = {};
                this.loading = false;
              })

              .catch(err => {
                this.$message({
                  message: err,
                  type: "warning",
                  customClass: "messageIndex"
                });
                console.log(err);
                this.loading = false;
              });
          }
        } else {
          // this.$message({
          //   message: "请输入正确的手机号和验证码",
          //   type: "warning",
          //   customClass: "messageIndex"
          // });
          return false;
        }
      });
    },
    // 发送验证码
    SendCode() {
      console.log("发送验证码");
      // 点击发送，清空验证码和手机号
      this.validation = {};
      GetVerificationCode({ LoginCode: this.form.phone })
        .then(res => {
          try {
            console.log(res);
            // 赋值手机号和验证码
            this.validation.Phone = res.Data.Phone;
            this.validation.VerificationCode = res.Data.VerificationCode;
            // 得到验证码和返回的手机号
            // console.log(!this.form.phone === "");
            // this.$refs["form"].validateField(["phone"], errorMsg => {
            //   if (!errorMsg) {
            //     // 计时器
            //     if (!this.timer) {
            //       this.countTime = TIME_COUNT;
            //       this.isshowMsgCode = false;
            //       this.timer = setInterval(() => {
            //         if (this.countTime > 0 && this.countTime <= TIME_COUNT) {
            //           this.countTime--;
            //         } else {
            //           this.isshowMsgCode = true;
            //           clearInterval(this.timer);
            //           this.timer = null;
            //         }
            //       }, 1000);
            //     }
            //   } else {
            //     console.log("error submit!!");
            //     return false;
            //   }
            // });
          } catch (err) {
            console.log("err", err);
          }
        })
        .catch(err => {
          console.log("err ", err);
        });
    },
    // 读秒的时候提示
    handleMsgVCode() {
      alert(`${{ countTime }}后，再试`);
    },
    // 跳转到用户协议
    UserAgreementHandle() {
      this.$router.push("/UserAgreement");
      this.$emit("update:visible", false);
    }
  }
};
</script>

<style>
.messageIndex {
  margin-top: 80px;
  z-index: 9999 !important;
  /* // 设置的值一定要比2007大，因为dialog的层级是2007 */
}
.el-message {
  top: 20px !important;
}
.el-message:not(:last-child) {
  visibility: hidden;
}
</style>

<style lang="less" scoped>
.login-main {
  padding: 0px 0px 0px 30px;
}
.ForgetPassword {
  cursor: pointer;
  text-align: right;
  // height: 14px;
  height: 0px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #5b90f0;
  margin: 22px;
}
/deep/ .messageIndex {
  z-index: 9999 !important;
  /* // 设置的值一定要比2007大，因为dialog的层级是2007 */
}
/deep/.el-dialog__header {
  padding: 65px 20px 10px;
}
/deep/.el-dialog {
  width: 366px;
  height: 460px;
  background: #ffffff;
  border-radius: 10px;
}

.certification {
  position: relative;
  // background: url(../../assets/img/盾牌保险认证.png) no-repeat;
  // background-size: 20px 20px;
  // top: 0px;
  img {
    position: absolute;
    top: 68px;
    left: 120px;
  }
  .code {
    position: absolute;
    top: 220px;
    left: 200px;
  }
  .msg_btn {
    position: absolute;
    top: 230px;
    left: 200px;
  }
}
.certification /deep/.el-input__inner {
  // margin-bottom: 29px;
  background-color: #fff;
  border: none;
  border-radius: 1px;
  width: 266px;
  /* border: 1px solid #dcdfe6; */
  height: 60px;
  line-height: 60px;
  border-bottom: 1px solid #ebebeb;
}
.el-button--primary {
  width: 266px;
  height: 40px;
  background: #5b90f0;
  border: 1px solid #ebebeb;
  border-radius: 6px;
  text-align: center;
}
/deep/.el-form-item__content {
  margin: 0px 0px 0px !important;
}
.el-input__prefix,
.el-input__suffix {
  height: 0px !important;
}
// 错误提示
/deep/.el-form-item__error {
  position: absolute;
  top: 100%;
  left: 30px !important;
}
// 按钮上边距
.el-button--primary[data-v-35056f12] {
  margin-top: 10px !important;
}
// 复选框，选中
/deep/.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #656565;
}
// 用户协议
.UserAgreement {
  cursor: pointer;
  color: #5b90f0;
}

.forget {
  cursor: pointer;
  color: #5b90f0;
  margin-top: 15px;
}
</style>

<style scoped lang="less">
/deep/.el-dialog__header {
  border-bottom: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dialog/login.vue